import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginInline: '1.125rem',
    width: '100%',
    maxWidth: 'calc(100vw - 2.25rem - 95px)',
    height: '100%',
    padding: '0 0 0.25rem 0',

    [theme.breakpoints.down('md')]: {
      maxWidth: 'calc(100vw - 1rem - 1.125rem)',
      marginRight: '1.125rem'
    }
  }
}))

export default useStyles
